import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  items: [],
  status: 'idle',
  error: null,
  size: 0
}

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    cartAdded(state, action) {
      const existingItem = state.items.find(item => item.product.id === action.payload.id)
      let count = 1
      if (existingItem) {
        //count = existingItem.amount + 1
        existingItem.amount++
      }
      else {
        state.items.push({amount: count, product: action.payload})
      }
      state.size++
    },
    cartUpdated(state, action) {
      const { amount, id } = action.payload
      const existingItem = state.items.find(item => item.product.id === id)
      existingItem.amount = amount
    },
    cartEmptied(state) {
      state.items = []
    }
  }
})

export const { cartAdded, cartUpdated, cartEmptied } = cartSlice.actions

export default cartSlice.reducer

export const selectAllCart = state => state.cart.items
export const selectCartSize = (state) => state.cart.items.length